import { Helmet } from 'react-helmet'
import { getStepNumber } from 'config/onboarding'
import { getTitle } from 'config/titles'
import Onboarding from 'components/Onboarding'
import { useNetwork } from '~/networkProvider'
import { FacilityScreenContainer } from '~/components/FacilityScreenContainer'

const OnboardingRoofsScreen = () => {
  const { online } = useNetwork()
  return (
    <FacilityScreenContainer>
      <Helmet>
        <title>{getTitle('roofs')}</title>
      </Helmet>
      <Onboarding
        online={online}
        step={getStepNumber('Roofs')}
        message="Draw and configure the roofs of your facility."
      />
    </FacilityScreenContainer>
  )
}

export default OnboardingRoofsScreen
